module.exports = __webpack_public_path__ + "static/media/WBD-FINAL_page-0002.38ff995e.jpg";